var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71967 3.96979C5.01256 3.6769 5.48732 3.6769 5.78022 3.96979L13.2802 11.4698C13.5731 11.7627 13.5731 12.2375 13.2802 12.5303L5.78022 20.0303C5.48734 20.3232 5.01257 20.3232 4.71967 20.0303C4.42678 19.7374 4.42678 19.2627 4.71967 18.9698L11.6894 12.0001L4.71967 5.03034C4.42678 4.73745 4.42678 4.26269 4.71967 3.96979Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7197 3.96979C11.0126 3.6769 11.4873 3.6769 11.7802 3.96979L19.2802 11.4698C19.5731 11.7627 19.5731 12.2375 19.2802 12.5303L11.7802 20.0303C11.4873 20.3232 11.0126 20.3232 10.7197 20.0303C10.4268 19.7374 10.4268 19.2627 10.7197 18.9698L17.6894 12.0001L10.7197 5.03034L10.6679 4.9737C10.4276 4.67912 10.4451 4.2444 10.7197 3.96979Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterArrows);
export default __webpack_public_path__ + "static/media/register-arrows.1278975af11487f7e0abcde8daf30f47.svg";
export { ForwardRef as ReactComponent };